import './mobile_nav.mobile_social_links.less';


import React, { Component } from 'react';
import PropTypes from 'prop-types';

import map from 'lodash/map';

import SocialLinkIcon from 'zoomforth_codesbane_viewer/viewer/header_legacy/social_link_icon.jsx';
import { getTracker } from 'zoomforth_codesbane_viewer/lib/global_store.js';


class MobileSocialLinks extends Component {
  

  render() {
    const { socialLinks } = this.props;
    
    return (
      <div className="mobile-social-links-wrapper">
        <div className="mobile-social-links">
          {
            map(socialLinks, (link, index) => (
              link.enabled &&
              <div 
                key={`soc-${index}`} 
                className={`mobile-social-icon-wrapper social-icon-for-${link.serviceName}`} 
                data-service-name={link.serviceName}>

                <a
                  href={link.link} 
                  target={link.target || '_blank'} 
                  onClick={(e)=>{
                    getTracker().handleSocialIconClick(e);
                    e.stopPropagation();
                  }}
                  className="social-icon-link">

                  <SocialLinkIcon serviceName={link.serviceName} />

                </a>

              </div>
            ))
          }
        </div>
      </div>
    );
  }
}

MobileSocialLinks.propTypes = {
  socialLinks: PropTypes.arrayOf(PropTypes.shape({
    serviceName: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
    target: PropTypes.string.isRequired
  }))
};



export default MobileSocialLinks;
